import React from 'react';

export default function Step7(props){
    return <div className="seehi_step">
        <h2>Subsidie aanvragen</h2>
        <p>U kunt subsidie aanvragen nadat het werk is voltooid. Houd bij de uitvoering rekening met de vereisten voor 
            de subsidieaanvraag. Er zijn bijvoorbeeld eisen voor de isolatiewaarden en de minimale oppervlakte. U moet 
            ook uitvoerdersformulieren en foto’s van de uitvoering hebben. Gebruik onderstaande checklist om te 
            voorkomen dat u iets vergeet.</p>
        <h3>Checklist: dit heeft u nodig voor de aanvraag</h3>
        <ul className="seehi_checklist">
            <li>Ingevulde en ondertekende uitvoerdersformulier(en) door het bouwbedrijf.</li>
            <li>Foto's van de uitgevoerde maatregelen. Deze zijn in het uitvoerdersformulier toe te voegen.</li>
            <li>Een bewijs van inschrijving van het bouwbedrijf in de Kamer van Koophandel.</li>
            <li>Bij een maatwerkadviesrapport: Naam, adres, inschrijfnummer bij de Kamer van Koophandel en het nummer van het certificaat van de certificaathouder waarvoor de adviseur werkt.</li>
            <li>Bij een maatwerkadviesrapport, indien van toepassing:  Naam, adres en examennummer van de betrokken EPA-adviseur.</li>
            <li>Bij een maatwerkadviesrapport: een verklaring dat voor dit rapport niet eerder subsidie is aangevraagd of toegekend.</li>
            <li>DigiD van de subsidieaanvrager.</li>
            <li>Bankrekeningnummer waar subsidie op moet worden uitgekeerd.</li>
            <li>Facturen en betaalbewijzen van de uitvoering.</li>
        </ul>

        <h3>Aanvraag indienen</h3>
        <p>Vraag uw subsidie aan via het eLoket op rvo.nl.</p>
        <a href="https://www.rvo.nl/subsidies-regelingen/seeh/eigenaar-%C3%A9n-bewoner" className="seehi_actionButton" target="_blank">Subsidie aanvragen</a>

        <h3>Wanneer ontvang ik mijn subsidie?</h3>
        <p>De wettelijke termijn voor het nemen van een besluit bedraagt 13 weken. RVO.nl probeert het besluit te nemen binnen 4 weken.</p>

    </div>;
}


// WEBPACK FOOTER //
// ./src/steps/step7.js